import { Box, Button } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { UseAttachedCompanies } from 'src/Libs/retrofit/hooks'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ListSkeleton } from '@e3dc-react/shell/Elements/Skeletons'
import { ErrorMessage } from '@e3dc-react/shell/Elements/Error'
import useModals from 'src/Hooks/useModals'
import CompaniesWithAccess from './CompaniesWithAccess'

const useStyles = makeStyles()(theme => ({
  grantAccessContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
}))

interface Props {
  installationId: string | undefined
  isInstallationDecommissioned: boolean
  attachedCompaniesHookResult: UseAttachedCompanies
  refetchData: () => void
}

/**
 * Wrapper component to display all companies that have access to an installation
 * @param installationId - installation id
 * @param attachedCompaniesHookResult - hook result for fetching companies with access
 * @param refetchData - function to refetch entire installation data
 */
const CompaniesWithAccessWrapper: React.FC<Props> = ({ installationId, isInstallationDecommissioned, attachedCompaniesHookResult, refetchData }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { data, isError, isLoading } = attachedCompaniesHookResult
  const { openGrantCompanyAccessModal } = useModals()

  const onGrantAccessHandler = (): void => {
    openGrantCompanyAccessModal({
      installationId: installationId ?? '',
      refetchAttachedCompanies: refetchData,
    })
  }

  return (
    <Box sx={{ marginLeft: -2 }}>
      {isLoading ? (
        <ListSkeleton length={3} />
      ) : isError ? (
        <ErrorMessage title={t('installation.details.info.companies-with-access-error')} />
      ) : (
        <CompaniesWithAccess
          companies={data}
          installationId={installationId}
          isInstallationDecommissioned={isInstallationDecommissioned}
          refetchAttachedCompanies={refetchData}
        />
      )}
      {!isInstallationDecommissioned && (
        <Box className={classes.grantAccessContainer}>
          <Button onClick={onGrantAccessHandler}>{t('installation.details.info.grant-access.button-title')}</Button>
        </Box>
      )}
    </Box>
  )
}

export default CompaniesWithAccessWrapper
